module.exports = __webpack_public_path__ + "img/who-are-you--tutor.806fde93.svg";